import { DateField, FunctionField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import { ActionButton } from '@/components/buttons';
import { path, SORT_OPTIONS } from '@/pages/Candidate/view/tabs/ChecksTab/constants';
import RequestCounty from '@/pages/Candidate/view/tabs/ChecksTab/RequestCounty';
import RequestMVR from '@/pages/Candidate/view/tabs/ChecksTab/RequestMVR';
import { ActionsContainer, CapitalizedFunctionField } from '@/pages/Candidate/view/tabs/ChecksTab/styled';
import useController from '@/pages/Candidate/view/tabs/ChecksTab/useController';
import { MainDatagridStyled } from '@/styles/overrides';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { FCRAWorker } from '@/types/turn-api';
import { getProcessingTime } from '@/utils';

const ChecksTab = (props: Partial<TabProps>) => {
  const controller = useController();

  return (
    <Tab label="requested checks" {...props}>
      {controller.showRequestCounty && <RequestCounty onClose={controller.toggleRequestCounty} />}
      {controller.showRequestMVR && <RequestMVR onClose={controller.toggleRequestMVR} />}

      {!controller.isFormOpen && (
        <>
          <ActionsContainer>
            <ActionButton
              iconType="addCircleOutline"
              label="Request MVR"
              onClick={controller.toggleRequestMVR}
              disabled={controller.cannotRequestMVR}
            />
            <ActionButton iconType="addCircleOutline" label="Request County" onClick={controller.toggleRequestCounty} />
          </ActionsContainer>

          <ReferenceManyField
            label=""
            reference={TurnReferencesEnum.Candidates}
            sort={SORT_OPTIONS}
            target={TurnTargetsEnum.BackgroundChecks}
          >
            <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
              <CapitalizedFunctionField label="Check" render={(record: FCRAWorker.BackgroundCheck) => record?.kind} />

              <TextField source={path('status')} />
              <TextField source={path('locality')} emptyText="-" />
              <TextField source={path('service')} sortable={false} />

              <FunctionField
                label="Processing Time"
                render={(record: FCRAWorker.BackgroundCheck) =>
                  !record?.created_at ? 'N/A' : getProcessingTime(record?.created_at, record?.completed_at)
                }
              />

              <DateField label="Check Date" source={path('created_at')} showTime />
              <TextField source={path('source')} sortable={false} />
              <TextField source={path('recheck_id')} sortable={false} />
            </MainDatagridStyled>
          </ReferenceManyField>
        </>
      )}
    </Tab>
  );
};

export default ChecksTab;
